module.exports = __webpack_public_path__ + "img/upmood_watch_2.bd7d3000.png";